import FAQArticle from "./FAQArticle";

export default class FAQSubCategory {
    public title : string = '';
    public articles : FAQArticle[] = [];
} 